import React from 'react';
import styled from 'styled-components';
import {basicColor, radius} from '../../../../styles/template';
import {hexToRgba} from '@/core/utils/colorUtils';

interface Props {
    children: React.ReactNode
    className?: string
    href?: string
}

const Wrap = styled.a`
    width: 100%;
    background: ${props => props.theme.color.Item};
    border-radius: ${radius.normal};
    position: relative;
    display: flex;
    gap: 2rem;
    align-items: center;
    padding: 12px 2rem;
    box-shadow: ${props => props.theme.boxShadow.Small};
    cursor: pointer;
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  
    &.active {
      box-shadow: none;
      background: ${hexToRgba(basicColor.primary, 0.2)};
      color: ${basicColor.primary};
      cursor: not-allowed;
    }

    &:hover:not(.active) {
        transform: translateY(-3px);
        box-shadow: ${props => props.theme.boxShadow.Middle};
    }
`

const Item: React.FC<Props> = props => {
    const { href, className, children } = props;
    return <Wrap className={className} href={href} >{children}</Wrap>
}

export default Item